module.exports = ".button-row button, .button-row a {\n    margin-right: 8px;\n}"